import { useRef } from "react";

// tabs prop: array of {key, label, icon, badge?}
export default function ProfileTabs({ active, onChange, tabs = [] }) {
  const scrollRef = useRef(null);

  // The scrollbar is deliberately hidden (clean look, natural touch-swipe on
  // mobile), but that leaves desktop users with no way to discover or perform
  // the scroll — translate vertical wheel input into horizontal movement,
  // the standard fix for a horizontally-scrolling strip like this.
  const handleWheel = (e) => {
    const el = scrollRef.current;
    if (!el || el.scrollWidth <= el.clientWidth) return;
    if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
      e.preventDefault();
      el.scrollLeft += e.deltaY;
    }
  };

  return (
    <div className="fc-profile-tabs" ref={scrollRef} onWheel={handleWheel}>
      {tabs.map(t => {
        const isActive = t.key === active;
        return (
          <button key={t.key} onClick={() => onChange(t.key)}
            className={`fc-profile-tab-btn${isActive ? " active" : ""}`}>
            <div className="fc-profile-tab-icon"
              style={{ background: isActive ? "rgba(255,255,255,0.15)" : "var(--fc-bg-light)" }}>
              <i className={`fa-solid ${t.icon}`} style={{ color: isActive ? "#fff" : "var(--fc-text-subtle)" }} />
            </div>
            {t.label}
            {t.badge > 0 && (
              <span className="badge rounded-pill ms-1"
                style={{ fontSize: 10, background: isActive ? "rgba(255,255,255,0.2)" : "var(--fc-blue-light)", color: isActive ? "#fff" : "var(--fc-blue)" }}>
                {t.badge}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
